import { Link, useParams } from "react-router-dom";
import { Button, Modal } from "semantic-ui-react";
import { useNotifySubscriberContactMethodsForLoggedInUser } from "../../../../../../hooks/useNotifySubscriberContactMethodsForLoggedInUser";
import { FocusScope } from "react-aria";

export function SignUpModal({ onClose, data }: { onClose: () => void; data: { type: "Email" | "Phone" } | null }) {
  const { site } = useParams<{ site: string }>();

  const { subscriberContactMethods } = useNotifySubscriberContactMethodsForLoggedInUser();
  const subscriberContactMethod = subscriberContactMethods?.at(0);

  const redirectSearchParams = new URLSearchParams();
  redirectSearchParams.set("action", `add-contact-method`);

  const signUpSearchParams = new URLSearchParams();
  signUpSearchParams.set("redirect", `/${site}/public/notify/subscription-groups?${redirectSearchParams.toString()}`);
  if (subscriberContactMethod && subscriberContactMethod?.type === "Email") {
    signUpSearchParams.set("email", subscriberContactMethod.identifier);
  }

  const signInSearchParams = new URLSearchParams();
  signInSearchParams.set("redirect", `/${site}/public/notify/subscription-groups?${redirectSearchParams.toString()}`);

  return (
    <Modal open={!!data} onClose={onClose} size='tiny' closeIcon>
      <Modal.Header>Sign Up to Add {data?.type === "Email" ? "Email Address" : "Phone Number"}</Modal.Header>
      <FocusScope contain autoFocus restoreFocus>
        <Modal.Content>
          <p>Add multiple contact methods, connect the mobile app, and more with an account.</p>
          <p>
            Already have an account?{" "}
            <Link
              to={{
                pathname: `/${site}/public/login`,
                search: `?${signInSearchParams.toString()}`,
              }}
            >
              Sign In
            </Link>
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={onClose}>
            Cancel
          </Button>
          <Button
            primary
            as={Link}
            to={{
              pathname: `/${site}/public/register`,
              search: `?${signUpSearchParams.toString()}`,
            }}
          >
            Sign Up
          </Button>
        </Modal.Actions>
      </FocusScope>
    </Modal>
  );
}
